import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "h-full flex items-center justify-center" }
const _hoisted_2 = { class: "text-primary text-center mb-20" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = {
  key: 0,
  class: "text-grey-dark text-body1"
}

import { BaseError } from '../plugins/errors/Errors'


export default /*#__PURE__*/_defineComponent({
  props: {
    error: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, [
      _createTextVNode(_toDisplayString(__props.error.title) + " ", 1),
      _hoisted_3,
      _createTextVNode(" " + _toDisplayString(__props.error.msg) + " ", 1),
      _hoisted_4,
      (__props.error.isAxiosError)
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.$t('inri.error.error_code', { code: __props.error.status })), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})